/*! @azure/msal-browser v4.25.1 2025-10-17 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const storageNotSupported = "storage_not_supported";
const stubbedPublicClientApplicationCalled = "stubbed_public_client_application_called";
const inMemRedirectUnavailable = "in_mem_redirect_unavailable";

export { inMemRedirectUnavailable, storageNotSupported, stubbedPublicClientApplicationCalled };
//# sourceMappingURL=BrowserConfigurationAuthErrorCodes.mjs.map
